const visitResetPassword = (memberId) => {
  return new Promise((resolve, reject) => {
    window.location = `manage/member/${memberId}/person_password_reset`;
  });
}

export default visitResetPassword;
